import { Box, Button, Card, default as Dialog, IconButton, Typography } from '@mui/material'
import MUIDataTable, { MUIDataTableColumnDef } from 'mui-datatables'
import { useEffect, useMemo, useState } from 'react'
import Header from '../Header'
import DeleteIcon from "@mui/icons-material/Delete";
import HtmlTooltip from '../html-tool-tip'
import CreateEdit, { LLMModels, LLMOptions } from './create-edit'
import { LLMConfigurationDataType } from '../../types'
import { useUserInfo } from '../../hooks/useUserinfo';
import Link from "@mui/material/Link";
import { SnackbarProvider } from 'notistack';
import TableLoader from "../table-loader";
import { convertDateToLocalTime } from '../../helper';
import moment from "moment"
import { getLLMConfiguration } from '../../apis/llm-configurations';
import "./llm-style.css"
import DeleteTopic from './delete-topic';

type Props = {}

const LLMConfiguration = (props: Props) => {
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [currentLLMConfiguration, setCurrentLLMConfiguration] = useState<LLMConfigurationDataType>();
    const userInfo = useUserInfo();
    const [loader, setLoader] = useState(true);
    const [view, setView] = useState(false);
    const [LLMConfigurationList, setLLMConfigurationList] = useState<(LLMConfigurationDataType)[]>([]);
    const columns: MUIDataTableColumnDef[] = useMemo(() => [
        {
            label: "Name",
            name: "llm_name",
            options: {
                customBodyRender: (value: string) => {
                    const llm = LLMOptions?.find(op => op.value === value);
                    return (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <img width="20" height="20" src={llm?.img} />
                            {llm?.name}
                        </Box>
                    )
                }
            },
        },
        {
            name: "llm_model_name",
            label: "Model",
            options: {
                customBodyRender: (value: string, row) => {
                    const llm = (LLMOptions?.find(options => options.value === row.rowData[0])?.value || "") as keyof typeof LLMModels;
                    const llmModal = llm ? LLMModels[llm]?.find(option => option?.value === value)?.label || value : value
                    return llmModal;
                },
            },
        },
        {
            label: "Thread Length",
            name: "thread_length",
        },
        // {
        //     label: "API Key",
        //     name: "api_key",
        //     options: {
        //         setCellProps: () => ({
        //             sx: { minWidth: { xs: "auto", md: "200px" }, maxWidth: { xs: "auto", md: "200px" } },
        //         }),
        //         customBodyRender: (value: string) => (
        //             value ? <ExpandableDescription description={value} /> : ""
        //         ),
        //     },
        // },
        {
            label: "Create At",
            name: "created_at",
            options: {
                customBodyRender: (value: string) => {
                    const dateTime = moment(convertDateToLocalTime(value, userInfo?.timezone)).format("MMM D, YYYY h:mm A");
                    return dateTime;
                }
            }
        },
        {
            label: "Action",
            name: "action",
            options: {
                filter: false,
                customBodyRender: (value) => {
                    return (
                        <>
                            {/* <HtmlTooltip
                                title={<Typography color="inherit">View LLM</Typography>}
                                placement="bottom"
                            >
                                <IconButton aria-label="view" onClick={() => { editTopic(value); setView(true) }}>
                                    <VisibilityIcon color="primary" />
                                </IconButton>
                            </HtmlTooltip> */}
                            <>
                                {/* <HtmlTooltip
                                        title={
                                            <Typography color="inherit">
                                                Edit LLM
                                            </Typography>
                                        }
                                        placement="bottom"
                                    >
                                        <IconButton
                                            aria-label="edit"
                                            onClick={() => editTopic(value)}
                                        >
                                            <EditIcon color="primary" />
                                        </IconButton>
                                    </HtmlTooltip> */}
                                <HtmlTooltip
                                    title={
                                        <Typography color="inherit">
                                            Delete LLM
                                        </Typography>
                                    }
                                    placement="bottom"
                                >
                                    <IconButton
                                        aria-label="delete"
                                        onClick={() => deleteTopic(value)}
                                    >
                                        <DeleteIcon color="error" />
                                    </IconButton>
                                </HtmlTooltip>
                            </>
                        </>
                    );
                },
            },
        }
    ], []);

    const handleCloseCreateModal = () => {
        setShowCreateModal(false);
        setCurrentLLMConfiguration(undefined);
        setView(false);
    }
    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setCurrentLLMConfiguration(undefined);
    }

    useEffect(() => {
        fetchLLMConfigurations();
    }, []);

    const fetchLLMConfigurations = async () => {
        setLoader(true)
        const data = await getLLMConfiguration();
        setLoader(false)
        setLLMConfigurationList(() => {
            return data?.map((value) => ({ ...value, action: value }));
        });

    }
    const deleteTopic = (LLMConfiguration: LLMConfigurationDataType) => {
        setCurrentLLMConfiguration(LLMConfiguration);
        setShowDeleteModal(true);
    }
    const [recordPerPage, setRecordPerPage] = useState(10);
    return (
        <>
            <SnackbarProvider anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }} />
            <Header title='LLM Configuration' />
            <Card sx={{ m: 3 }}>
                {loader ? <TableLoader rows={5} /> :
                    <MUIDataTable
                        title={""}
                        data={LLMConfigurationList}
                        columns={columns}
                        options={{
                            sort: true,
                            print: false,
                            download: false,
                            viewColumns: false,
                            selectableRows: 'none',
                            filter: true,
                            responsive: "vertical",
                            serverSide: false,
                            rowsPerPage: recordPerPage,
                            rowsPerPageOptions: [10, 20, 50, 100],
                            onChangeRowsPerPage: (currentRowsPerPage) => setRecordPerPage(currentRowsPerPage),
                            customToolbar: () => {
                                return (
                                    <Button variant="contained" onClick={() => setShowCreateModal(true)}>
                                        Create LLM
                                    </Button>
                                )
                            }
                        }}
                    />}
            </Card>
            {showCreateModal && <CreateEdit view={view} fetchLLMConfigurations={fetchLLMConfigurations} currentLLMConfigurationData={currentLLMConfiguration} handleCloseCreateModal={handleCloseCreateModal} open={showCreateModal} />}
            {showDeleteModal && <DeleteTopic setLLMConfigurationList={setLLMConfigurationList} currentLLMConfiguration={currentLLMConfiguration} handleCloseDeleteModal={handleCloseDeleteModal} open={showDeleteModal} />}
        </>
    )
}

export default LLMConfiguration;

export const ExpandableDescription = ({ description }: { description: string }) => {
    const [expanded, setExpanded] = useState(false);
    const toggleExpand = () => setExpanded(!expanded);
    const characterLimit = 14;
    const truncatedDescription =
        description.length > characterLimit
            ? `${description.substring(0, characterLimit)}... `
            : description;

    return (
        <Box
            sx={{
                display: expanded ? "block" : "flex",
                flexDirection: expanded ? "column" : "row",
                justifyContent: "flex-start",
                alignItems: "center",
            }}
        >
            <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
                {expanded ? description : truncatedDescription}
                {description.length > characterLimit && (
                    <Link
                        component="button"
                        variant="body2"
                        onClick={toggleExpand}
                        sx={{ marginTop: "0px", marginLeft: expanded ? "5px" : "0px", textDecoration: "none" }}
                    >
                        {expanded ? ` Less` : ` More`}
                    </Link>
                )}
            </Typography>

        </Box>
    );
};

